!function(){let _mdColors=window.invokeAngularService("$mdColors");window.ThemeColor=class{static _getColorService(){return _mdColors||(_mdColors=window.invokeAngularService("$mdColors"))}static getThemeColor(expression){return this._getColorService().getThemeColor(expression)}}}();
//# sourceMappingURL=theme_color.class.es6.js.map
;
